export const labelClass = {
  I: 'purple',
  S: 'red',
  O: 'green',
  E: 'pink',
};

export const pactTypeTitle = {
  I: '입원',
  S: '수술',
  O: '외래',
  E: '응급',
};

export const pactTypeClass = {
  I: 'inpatient',
  S: 'surgery',
  O: 'outpatient',
  E: 'emergency',
};

export const testType = {
  SPC: '검체',
  IMG: '영상',
  FUNC: '기능',
  // PAT: '병리',
};

